/* ============================================================
   BIBLIA ANIMADA — motor compartido
   Animaciones al hacer scroll y cintas infinitas. Sin librerías.
   ============================================================ */
(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Animaciones al entrar en pantalla ---------- */

  var revealObserver = null;

  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('[data-ba-reveal]:not(.ba-in)');
    if (!nodes.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].classList.add('ba-in', 'ba-done');
      }
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('ba-in');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );
    }

    for (var j = 0; j < nodes.length; j++) revealObserver.observe(nodes[j]);
  }

  /* Cuando una entrada termina, marcamos el elemento como
     terminado. El CSS aprovecha esa marca para fijar el estado
     final con valores estáticos y soltar la capa gráfica en un
     cambio controlado. Sin esto, el navegador destruía la capa
     por su cuenta a mitad de fotograma y se veía un saltito. */
  function markDone(e) {
    var el = e.target;
    if (!el || el.nodeType !== 1 || !el.hasAttribute) return;
    if (!el.hasAttribute('data-ba-reveal')) return;
    if (!el.classList.contains('ba-in')) return;
    el.classList.add('ba-done');
  }

  document.addEventListener('animationend', markDone, true);
  document.addEventListener('transitionend', markDone, true);

  /* Red de seguridad: si por lo que sea no llegara el aviso de
     fin, cerramos la animación a los 4 segundos. */
  function sweep() {
    document.querySelectorAll('.ba-in:not(.ba-done)[data-ba-reveal]').forEach(function (el) {
      if (!el.__baT) {
        el.__baT = setTimeout(function () { el.classList.add('ba-done'); }, 4000);
      }
    });
  }

  /* ---------- 2. Cintas infinitas ---------- */

  var marquees = [];
  var rafId = null;

  function measure(m) {
    var kids = m.track.children;
    if (!m.unit || kids.length <= m.unit) return;

    var period = kids[m.unit].offsetLeft - kids[0].offsetLeft;
    if (period <= 0) return;

    if (m.period && m.period !== period) m.x = m.x % period;
    m.period = period;

    var needed = m.el.clientWidth + period * 2;
    var guard = 0;
    while (m.track.scrollWidth < needed && guard < 10) {
      for (var i = 0; i < m.unit; i++) {
        var clone = kids[i].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        m.track.appendChild(clone);
      }
      guard++;
    }
  }

  function remeasureAll() {
    for (var i = 0; i < marquees.length; i++) measure(marquees[i]);
  }

  function initMarquee(root) {
    var nodes = (root || document).querySelectorAll('[data-ba-marquee]');

    for (var i = 0; i < nodes.length; i++) {
      (function (el) {
        if (el.__ba) return;
        el.__ba = true;

        var track = el.querySelector('.ba-marquee__track');
        if (!track || track.children.length < 2) return;

        var m = {
          el: el, track: track, x: 0, period: 0, fling: 0, vel: 0,
          unit: track.children.length / 2,
          speed: parseFloat(el.getAttribute('data-speed') || '0.6'),
          dir: el.getAttribute('data-dir') === 'right' ? 1 : -1,
          visible: false, paused: false, dragging: false
        };

        el.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'mouse') m.paused = true;
        });
        el.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'mouse') m.paused = false;
        });

        el.addEventListener('pointerdown', function (e) {
          m.dragging = true; m.fling = 0; m.vel = 0;
          var startX = e.clientX, baseX = m.x, lastX = e.clientX;
          var lastT = performance.now();

          if (el.setPointerCapture) {
            try { el.setPointerCapture(e.pointerId); } catch (err) {}
          }

          function move(ev) {
            var now = performance.now();
            var dt = now - lastT;
            if (dt > 0) {
              m.vel = ((ev.clientX - lastX) / dt) * 16.7;
              lastX = ev.clientX;
              lastT = now;
            }
            m.x = baseX + (ev.clientX - startX);
          }
          function up() {
            m.dragging = false;
            m.fling = Math.max(-45, Math.min(45, m.vel));
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', up);
            window.removeEventListener('pointercancel', up);
          }
          window.addEventListener('pointermove', move);
          window.addEventListener('pointerup', up);
          window.addEventListener('pointercancel', up);
        });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            function (entries) { m.visible = entries[0].isIntersecting; },
            { rootMargin: '120px' }
          ).observe(el);
        } else {
          m.visible = true;
        }

        if ('ResizeObserver' in window) {
          var settle;
          new ResizeObserver(function () {
            clearTimeout(settle);
            settle = setTimeout(function () { measure(m); }, 120);
          }).observe(track);
        }

        marquees.push(m);
        measure(m);
      })(nodes[i]);
    }

    if (marquees.length && !rafId && !reduced) rafId = requestAnimationFrame(tick);
  }

  function tick() {
    for (var i = 0; i < marquees.length; i++) {
      var m = marquees[i];
      if (!m.visible) continue;
      if (m.el.hasAttribute('data-stop')) continue;
      if (!m.period) { measure(m); continue; }

      if (!m.dragging) {
        var base = m.paused ? 0 : m.speed * m.dir;
        m.x += base + m.fling;
        if (m.fling) {
          m.fling *= 0.93;
          if (Math.abs(m.fling) < 0.05) m.fling = 0;
        }
      }

      while (m.x <= -m.period) m.x += m.period;
      while (m.x > 0) m.x -= m.period;

      m.track.style.transform = 'translate3d(' + m.x.toFixed(2) + 'px,0,0)';
    }
    rafId = requestAnimationFrame(tick);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(remeasureAll, 250);
  });

  /* ---------- Arranque ---------- */

  function boot(root) {
    initReveal(root);
    initMarquee(root);
    sweep();
  }

  document.documentElement.classList.add('ba-js');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  window.addEventListener('load', remeasureAll);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(remeasureAll).catch(function () {});
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    marquees = marquees.filter(function (m) {
      return e.target.contains(m.el) === false;
    });
  });

  window.BA = { boot: boot };
})();
